import React from "react";
import PageContainer from "../../components/common/PageContainerAuth";
import MailingRulesSection from "../../components/pages/mailing-rules/MailingRulesSection";

export default function MailingRules() {
    return (
        <PageContainer section="mailings" pageTitle="Envois configurés">
            <MailingRulesSection />
        </PageContainer>
    );
}